import { Header, Icon, Input, theme } from '@salecycle/ui-component-library';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styled from 'styled-components';
import BrowseAbandonment from 'entities/campaign/rules/BrowseAbandonment';
import { Props } from './props';
import { Actions } from 'sections/campaigns/state/rulesets';
import { millisecondsToMinutes, minutesToMilliseconds } from '../../utils/time';

export type FormProps = Props<BrowseAbandonment>;

const StyledUnorderedList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  svg {
    margin-right: 10px;
  }

  li {
    margin-bottom: 5px;
  }
`;

export const Form: React.FC<FormProps> = props => {
  const { t } = useTranslation('campaigns');
  const onMinSessionTimeChange = (value: string) => {
    props.update(props.rulesetId, props.ruleIndex, {
      ...props.rule,
      minSessionTime: minutesToMilliseconds(parseInt(value, 10)),
    });
  };

  const getValidationMessage = (minSessionTime: number): string => {
    if (Number.isNaN(minSessionTime) || minSessionTime <= 0) {
      return t('campaigns:rules.browseAbandonment.invalidMessage');
    }
  };

  return (
    <div data-testid="BrowseAbandonment">
      <Header heading={t('campaigns:rules.browseAbandonment.coreRules')} />
      <StyledUnorderedList>
        <li>
          <Icon color={theme.vars.newColor.green1} icon="check-circle" />
          {t('campaigns:rules.browseAbandonment.rules.firstRule')}
        </li>
        <li>
          <Icon color={theme.vars.newColor.green1} icon="check-circle" />
          {t('campaigns:rules.browseAbandonment.rules.secondRule')}
        </li>
        <li>
          <Icon color={theme.vars.newColor.green1} icon="check-circle" />
          {t('campaigns:rules.browseAbandonment.rules.thirdRule')}
        </li>
      </StyledUnorderedList>

      <hr />

      <Input
        ariaLabel={t('campaigns:rules.browseAbandonment.minSessionTimeInput.ariaLabel')}
        inputId="MinimumSessionTimeInput"
        onChange={onMinSessionTimeChange}
        label={t('campaigns:rules.browseAbandonment.minSessionTimeInput.label')}
        type="number"
        placeholder={t('campaigns:rules.browseAbandonment.minSessionTimeInput.placeholder')}
        name="session-length-input"
        value={
          !!props.rule.minSessionTime
            ? Number.isNaN(props.rule.minSessionTime)
              ? String(props.rule.minSessionTime)
              : String(millisecondsToMinutes(props.rule.minSessionTime))
            : ''
        }
        validationState={
          !Number.isNaN(props.rule.minSessionTime) && props.rule.minSessionTime > 0 ? 'complete' : 'warning'
        }
        validationMessage={getValidationMessage(props.rule.minSessionTime)}
      />
    </div>
  );
};

const actions = { update: Actions.editRule };

export default connect(null, actions)(Form);
